import { Alert, Typography, Grid2, Button } from "@mui/material";
import SettingsCard from "../../base/SettingsCard";
import SettingsFormField from "../forms/SettingsFormField";
import { ProfileValidationData } from "@/utils/validateProfileData";

export interface ProfileInfoCardProps {
    profileData: ProfileValidationData;
    setProfileData: React.Dispatch<React.SetStateAction<ProfileValidationData>>;
    profileErrors: Record<string, string>;
    onSave: () => void;
}

export const ProfileInfoCard = ({ profileErrors, profileData, setProfileData, onSave }: ProfileInfoCardProps) => {
    return (
        <SettingsCard title="Persönliche Informationen">
            {/* Fehleranzeige */}
            {Object.keys(profileErrors).length > 0 && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {Object.values(profileErrors).map((error, index) => (
                        <Typography key={index}>{error}</Typography>
                    ))}
                </Alert>
            )}

            <Grid2 container size={12} spacing={2}>
                <SettingsFormField
                    label="Name"
                    value={profileData.name}
                    onChange={(e) => setProfileData((prev: ProfileValidationData) => ({ ...prev, name: e.target.value }))}
                    error={profileErrors.name}
                />
                <SettingsFormField
                    label="Titel"
                    value={profileData.title || ""}
                    onChange={(e) => setProfileData((prev: ProfileValidationData) => ({ ...prev, title: e.target.value }))}
                    error={profileErrors.title}
                />
            </Grid2>

            <Grid2 size={12} mt={2}>
                <Button variant={"contained"} onClick={onSave}>
                    Speichern
                </Button>
            </Grid2>
        </SettingsCard>
    );
};
